/**
 * Translation key for the system-settings entry in the menu and toolbar.
 *
 * The Debug-Mail card only exists in the test system, so on live the page is
 * nothing but the maintenance mode and is named after it — the umbrella
 * "Systemeinstellungen" only applies while both cards are shown.
 */
export function systemSettingsTitleKey(
    showMaintenance: boolean,
    showDebugMail: boolean
): string {
    if (showMaintenance && showDebugMail) {
        return 'page.p_sst';
    }
    return showMaintenance ? 'psst.tab_0_title' : 'psst.tab_1_title';
}
